import { Component, Inject, OnInit, Optional } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { MatDialog } from '@angular/material/dialog';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/services/api.service';
import { SuccessExcelModalComponent } from '../../../email-modal/email-modal/success-excel-modal/success-excel-modal.component';
/**
 * A function that validates multiple email addresses.
 * @returns A ValidatorFn that can be used with Angular forms.
 */
export function multipleEmailsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // If there is no value, there is no error
    if (!control.value) {
      return null;
    }
    // Split the value into a list of email addresses
    const emails = control.value.split(',').map((email) => email.trim());
    // A regular expression to validate email addresses
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // Find the email addresses that do not match the pattern
    const invalidEmails = emails.filter((email) => !emailPattern.test(email));
    // If there are any invalid email addresses, return an error
    return invalidEmails.length > 0
      ? { invalidEmails: invalidEmails.join(', ') }
      : null;
  };
}
@Component({
  selector: 'app-connect-with-incubator-email',
  templateUrl: './connect-with-incubator-email.component.html',
  styleUrls: ['./connect-with-incubator-email.component.css'],
})
export class ConnectWithIncubatorEmailComponent implements OnInit {
  emailForm: FormGroup;
  datas;
  private listApi = environment.url + environment.connectWithIncubators;
  /**
   * Constructs a new ConnectWithIncubatorEmailComponent.
   * @param fb FormBuilder to create forms.
   * @param getdata ValueService to manage application values.
   * @param makeapi ApiService to handle API requests.
   * @param notify NotifyService to handle notifications.
   * @param data The data that has been passed from the parent component.
   * @param dialogRef The dialog reference.
   * @param dialog The dialog to manage dialog operations.
   */
  constructor(
    private fb: FormBuilder,
    private getdata: ValueService,
    private makeapi: ApiService,
    private notify: NotifyService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConnectWithIncubatorEmailComponent>,
    public dialog: MatDialog
  ) {
    /**
     * The data that has been passed from the parent component.
     * Contains the search criteria.
     */
    this.datas = data;
    /**
     * The form group for the email form.
     * Contains the email field, which is required and must be a valid email.
     */
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, multipleEmailsValidator()]],
    });
  }
  get add() {
    return this.emailForm.controls;
  }
  ngOnInit(): void {}
  /**
   * Sends an email to the specified email addresses with the list of incubators.
   * The method retrieves the list of incubators based on the search criteria and
   * sends an email to the specified email addresses with the list of incubators.
   *
   * @param getform The form data containing the email addresses
   */
  ExcelSave() {
    let getform = this.emailForm.value;
    if (this.emailForm.invalid) {
      // If the form is invalid, mark all fields as touched and show an error message
      this.emailForm.markAllAsTouched();
      this.notify.notifyError('Please fill the mandatory fields !!');
      return;
    } else {
      // If the form is valid, show a loading indicator and close the dialog
      this.getdata.amizhthLoader('show');
      this.dialogRef.close();
      // Set the search string to an empty string if it is undefined
      if (this.datas._key.searchString == undefined) {
        this.datas._key.searchString = '';
      }
      // Create the request object
      let req = {
        listSize: this.datas._key.listSize,
        pageNumber: this.datas._key.pageNumber,
        searchString: this.datas._key.searchString,
        purpose: this.datas._key.purpose,
        incubatorId: this.datas._key.incubatorId,
        email: getform.email,
      };
      // Make the API call to send the email
      return this.makeapi
        .method(this.listApi, req, 'post')
        .subscribe((data) => {
          // Hide the loading indicator
          this.getdata.amizhthLoader('hide');
          // Show a success message
          this.notify.notifysuccess(data.responseMessage);
          // Reset the form
          this.emailForm.reset();
          // Close the dialog
          this.dialogRef.close();
          // Open the success dialog
          this.openModal();
        });
    }
  }
  dialogRefs;
  openModal() {
    this.dialogRefs = this.dialog.open(SuccessExcelModalComponent, {
      width: '600px',
      height: '320px',
    });
    this.dialogRefs.afterClosed().subscribe((result) => {});
  }
  /**
   * Closes the dialog without performing any action.
   * Resets the form and closes the dialog.
   */
  cancel(): void {
    // Reset the form fields
    this.emailForm.reset();
    // Close the dialog
    this.dialogRef.close();
  }
}
